import styled from 'styled-components';

export const Card = styled.div`
	background: ${(p) => p.theme.gray[0]};
	padding: 32px;
	border-radius: 12px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
	border: 1px solid ${(p) => p.theme.gray[200]};
`;

export const Description = styled.p`
	font-size: 14px;
	color: ${(p) => p.theme.gray[600]};
	line-height: 1.5;
	margin: 0 0 24px 0;
`;

export const ShareRow = styled.div`
	display: flex;
	gap: 12px;
	margin-bottom: 24px;
`;

export const ShareInput = styled.input`
	flex: 1;
	height: 44px;
	padding: 0 16px;
	background: ${(p) => p.theme.gray[100]};
	color: ${(p) => p.theme.gray[800]};
	border: 1px solid ${(p) => p.theme.gray[200]};
	border-radius: 8px;
	font-size: 14px;
	font-family: inherit;
	outline: none;

	&:focus {
		border-color: ${(p) => p.theme.blue[400]};
	}
`;

export const StatsRow = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
	margin-bottom: 24px;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

export const StatItem = styled.div`
	background: ${(p) => p.theme.gray[100]};
	padding: 16px;
	border-radius: 8px;
`;

export const StatLabel = styled.div`
	font-size: 12px;
	color: ${(p) => p.theme.gray[400]};
	margin-bottom: 4px;
`;

export const StatValue = styled.div`
	font-size: 20px;
	font-weight: 600;
	color: ${(p) => p.theme.gray[1000]};
`;
